import { SerializedConstructor } from '@langchain/core/load/serializable';
import { Input } from '@mui/joy';

import { cn } from '@/utils/tailwind';

import {
  ManifestEditorProps,
  ManifestPreviewProps,
  tableVariantLabelClass,
  tableVariantRowClass,
} from '../../Manifest.utils';
import {
  ManifestChatOpenAI,
  ManifestChatOpenAIPreview,
} from './ManifestChatOpenAI';

export function ManifestCustomModelEndpoint(
  props: ManifestEditorProps<SerializedConstructor>
) {
  return <ManifestChatOpenAI {...props} isCustomModelEndpoint={true} />;
}

export function ManifestCustomModelEndpointPreview(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  return <ManifestChatOpenAIPreview {...props} isCustomModelEndpoint={true} />;
}

export function CustomModelInput({
  baseUrl,
  onChange,
  readOnly,
  variant,
}: {
  baseUrl: string;
  onChange: (baseUrl: string) => void;
  readOnly: boolean;
  variant: string;
}) {
  if (variant === 'table') {
    return (
      <div
        className={cn(
          'flex flex-col items-stretch gap-2',
          tableVariantRowClass
        )}
      >
        <span
          className={cn('my-auto text-sm font-medium', tableVariantLabelClass)}
        >
          Base URL
        </span>

        <div className="overflow-hidden text-ellipsis">{baseUrl}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-medium">Base URL</div>
      <Input
        readOnly={readOnly}
        value={baseUrl}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
      {!readOnly && (
        <div className="text-xs text-secondary">
          Endpoint must comply with the{' '}
          <a
            href="https://platform.openai.com/docs/api-reference/chat/create"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-primary underline hover:text-brand-tertiary"
          >
            OpenAI API
          </a>
          . Defaults to OpenAI if left blank.
        </div>
      )}
    </div>
  );
}
